import React, { useEffect,  useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';

import { useNavigate } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';
import { PageMenuElement } from '../elements/page_menu.js';


export function ReportCurrentROsForm() {


    const [pageData, setPageData] = useState();
   const [reportData, setReportData] = useState([]);
    
    const navigate = useNavigate();
    

    const { MakeCall } = useAPICall();


    const handleDataFetch = (data) => {
        setPageData(data);
        setReportData(data.components['report_data']);


    }
    useEffect(() => {
        MakeCall('reports/getcurrentroreportdata', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
    });


 
    function handleNav(destination, state) {
        navigate(destination, state);
    }
   

   

    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/AdminReports");
                break;
           
            default:
                break;
        }
    }


    return (

        <div>

            {SecurityElement(pageData)}
            {MenuForm()}
            
            <div className="contentdiv">
            {PageMenuElement("Reports", [{ "name": "Back", "onclick": "goback" }], onPageMenuClick)}
              
                <div className='formbox'>
                    <div className='formtitle'>Current Range Officers Report</div>
                    <div className='formrow' key='reports' style={{"paddingBottom":"25px"}}>
                       This report shows current ROs.                                         
                    </div>                    
        
                    {reportData.map((member) => (
                            <div className='gridrow' key={member.idpeveril_member} style={{"paddingTop" : "10px", "paddingBottom" : "10px"}}>                                
                                <div className='gridcell' style={{ "width": "100%" }}>
                                    <div style={{ "fontWeight": "bold"}}>{member.forename} {member.surname}</div>
                                    <div>Last RO'd : {member.formatted_last_visit}</div>                                   
                                    <div>Mob : {member.mobile_number}</div>
                                    <div>Email : {member.email}</div>
                                        
                                </div>
                                
                            </div>                            
                        ))}
                    
                </div>

           
            </div>
        </div>


    );
}
